import { Link } from 'react-router-dom';

import { Button, Flex, Image } from 'antd';

import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Icon } from '@eduzz/ui-antd-theme';

const Header = () => {
  return (
    <Flex component='header' align='center' justify='space-between' className='eduzz-ui-layout-topbar-header px-8 py-3'>
      <Link to='/'>
        <Image
          preview={false}
          height={32}
          className='h-full w-40 object-contain object-left'
          alt='MyEduzz'
          src='https://cdn.eduzzcdn.com/topbar/myeduzz.svg'
        />
      </Link>
      <Button onClick={() => eduzzAccountsService.logout()} icon={<Icon.LogOut />}>
        Sair
      </Button>
    </Flex>
  );
};

export default Header;
